import axios from 'axios';

import {API_URL} from './constants';

const contactSupport = async (data: {category: string, description: string}): Promise<void> => {
    const res = await axios.post(`${API_URL}/contact-support`, data);
    return res.data;
};

export const supportApi = {
    contactSupport
};